import * as React from 'react'
import Link from 'next/link'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import SignUpForm from './Form'
import useStyles from 'src/styles/pages/auth/signup'
import { getCookie } from 'cookies-next'

const SignUp: React.FC = () => {
  const { classes } = useStyles()
  const lang = getCookie('lang')
  return (
    <>
      <Box component="div" className={classes.root}>
        <Typography variant="h2" className={classes.header}>
          {lang === 'En'
            ? 'WELCOME TO DITCH THE LABEL'
            : 'BIENVENIDX A QUÍTATE LAS ETIQUETAS'}
        </Typography>
        <SignUpForm />
        <Box component="div" className={classes.authLink}>
          <Typography variant="body2" className={classes.createLink}>
            {lang === 'En'
              ? 'ALREADY HAVE AN ACCOUNT?'
              : '¿YA TIENES UNA CUENTA?'}
            {'  '}
            <Link href="/auth/login" className={classes.link}>
              {lang === 'En' ? 'LOG IN' : 'Ingresar'}
            </Link>
          </Typography>
        </Box>
        <Box className={classes.bottomGradient}></Box>
      </Box>
    </>
  )
}

export default SignUp
